module.exports = __webpack_public_path__ + "img/logo_poweredby_clinicarx_77x36.d4fc1309.svg";